import React, { type FC, memo } from "react";
import type { TyreType } from "../../../../../../../../common-deprecated/types/CommonTypes";
import TyreDetails from "./TyreDetails";
import Button from "../../../../../../shared-components/css-modules/toyota/atoms/Button";
import styles from "./Wheels.module.scss";
import { CarConfigLabel } from "../../../../../utils/labelUtils";

const WheelDetails: FC<{
    tyres: TyreType[] | undefined;
    isActive: boolean;
    onClickHandler: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}> = ({ tyres, isActive, onClickHandler }) => {
    if (!tyres) return null;

    return (
        <>
            {tyres.map((tyre) => (
                <TyreDetails key={tyre.id} tyre={tyre} />
            ))}

            {!isActive && (
                <Button onClick={onClickHandler} className={styles["select-wheel-button"]}>
                    <CarConfigLabel label="carConfigSelectWheel" />
                </Button>
            )}
        </>
    );
};

export default memo(WheelDetails);
